<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { exportLead } from '@/utils/lead';
import { changeLeadStage } from '@/utils/lead';
import { VueDraggableNext } from "vue-draggable-next";

export default {
 inject: ['setLoading'],
 components: {
  draggable: VueDraggableNext,
 },
 data() {
  return {
   title: "CRM",
   text: "CRM",
   user: '',
   stage: '',
   source: '',
   search_keyword: '',
   data: [],
   users: [],
   stages: [],
   sources: [],
   selected_rows: [],
   stagePagination: {}, // Track pagination for each stage
   stageLoading: {}, // Track loading state for each stage
  };
},

 computed: {
  text1(){
   const totalLeads = this.data.reduce((sum, stage) => sum + (stage.total_leads_count || 0), 0);
   return `Leads (${totalLeads})`;
  },
  allSelected() {
   return this.data?.length && this.selected_rows.length === this.data.length;
  }
 },

mounted(){
 // Initialize filters from query parameters
 this.stage = this.$route.query.lead_stage_id || '';
 this.user = this.$route.query.user_id || '';
 this.source = this.$route.query.lead_source_id || '';
 this.search_keyword = this.$route.query.search || ''; 
  
 this.leads();
 this.getUsers();
 this.getStages();
 this.getSources();
}, 

methods: {
 
 handleToggleAll(event){
  // Only select rows that are not converted
  if(event.target.checked){
   // Select only leads that can be checked (converted_at is null)
   this.selected_rows = this.data.filter(row => row.converted_at === null).map(row => row.id);
  }else{
   // Uncheck all
   this.selected_rows = [];
  }
 },

 async changeStage(lead_id, stage_id){
  this.setLoading(true);
   try{
    const response = await changeLeadStage(lead_id, stage_id);
    this.$swalToast(response.data.message);
    this.leads();
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
 },

 async getStages(){
  this.setLoading(true);
  try{
   const response = await axios.get('/lead-stages');
   this.stages = response.data.data;
  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
 },

 async getSources(){
  this.setLoading(true);
  try{
   const response = await axios.get('/lead-sources');
   this.sources = response.data.data;
  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
 },

 async getUsers(){
  this.setLoading(true);
  try{
   const response = await axios.get('/users/all-users');
   this.users = response.data.data;
  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
 },

 async leads() {
  this.setLoading(true);
  try{
   const params = {
    user_id: this.user || '',
    lead_stage_id: this.stage || '',
    lead_source_id: this.source || '',
    search_keyword: this.search_keyword.trim() || ''
   };
   const query_string = new URLSearchParams(params).toString(); 
   const response = await axios.get(`/leads/kanban?${query_string}`);
   this.data = response.data.data;

   // Initialize stage pagination
   this.initializeStagePagination();

  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
 },

 initializeStagePagination() {
  this.stagePagination = {};
  this.stageLoading = {};
  
  this.data.forEach(stage => {
    this.stagePagination[stage.id] = 2; // Start from page 2 since page 1 is already loaded
    this.stageLoading[stage.id] = false;
  });
 },

 async loadMoreLeads(stageId, stageIndex){
  if(this.stageLoading[stageId]) return;
  this.stageLoading[stageId] = true;
  
  try {
    const params = {
      load_more: true,
      stage_id: stageId,
      page: this.stagePagination[stageId],
      user_id: this.user || '',
      lead_source_id: this.source || '',
      search_keyword: this.search_keyword.trim() || ''
    };
    
    const query_string = new URLSearchParams(params).toString();
    const response = await axios.get(`/leads/kanban?${query_string}`);
    
    // The data is at response.data.data (not response.data.data.data)
    const loadMoreData = response.data.data;
    
    // Check if we have leads to add
    if(loadMoreData && loadMoreData.leads && Array.isArray(loadMoreData.leads)){
     // Append new leads to existing ones
     this.data[stageIndex].leads.push(...loadMoreData.leads); 
     // Update stage info
     this.data[stageIndex].has_more_leads = loadMoreData.has_more;
     this.data[stageIndex].current_leads_count = loadMoreData.current_count; 
     // Update pagination
     this.stagePagination[stageId]++; 
     //this.toast.success(`Loaded ${loadMoreData.leads.length} more lead(s)`);
    }else{
     console.error('No leads found in response:', loadMoreData);
     this.$swalToast('No more leads found', 'error');
    }
    
  }catch(error){
   console.error('Load more error:', error);
   this.$swalToast(error.message, 'error' || 'Error loading more leads');
  }finally{
   this.stageLoading[stageId] = false;
  }
 },

 async exportFile(format) {
  await exportLead({
    format,
    ids: this.selected_rows,
    setLoading: this.setLoading,
    toastError: (msg) => this.$swalToast(msg, 'error'),
    timeStamp: () => this.$timeStamp(),
  });
 },

 bulkAction(){
  if(this.selected_rows.length){
   this.$refs.leadModal.bulkAction(this.selected_rows); 
   const modalEl = document.getElementById("bulk_action_lead");
   let modal = Modal.getInstance(modalEl);
   if(!modal){ modal = new Modal(modalEl);}
   modal.show();
  }else{
   this.$swalToast("Please select at least one option.", 'warning');
  }
 }, 

 clearFilter(){
  this.user = '';
  this.stage = '';
  this.source = '';
  this.search_keyword = '';
  this.leads();
 },

 onDragEnd(evt){  
  // Get the moved item's index in the new position
  const newIndex = evt.newIndex;
  const oldIndex = evt.oldIndex;
  
  // Find which stage it was dropped into
  const newStageElement = evt.to.closest('.kanban-list-items');
  const newStageIndex = Array.from(document.querySelectorAll('.kanban-list-items')).indexOf(newStageElement);
  
  // Find which stage it came from
  const oldStageElement = evt.from.closest('.kanban-list-items');
  const oldStageIndex = Array.from(document.querySelectorAll('.kanban-list-items')).indexOf(oldStageElement);
  
  // Check if stages are different
  if(newStageIndex !== oldStageIndex && newStageIndex >= 0 && oldStageIndex >= 0){
   // Get the lead that was moved from the new stage's leads array
   const movedLead = this.data[newStageIndex].leads[newIndex]; 
   if(movedLead){
    const newStageId = this.data[newStageIndex].id;
    const leadId = movedLead.id;  
    //Call the stage change method
    this.changeStage(leadId, newStageId);
   }else{
    console.error('Could not find moved lead');
   }
  }else{
   console.log('Same stage or invalid indices');
  }
 },

 },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
  <breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">

  <div class="me-2 mb-2">
   <div class="d-flex align-items-center border bg-white rounded p-1 me-2">
    <router-link to="/crm/leads-list" class="btn btn-icon btn-sm me-1" title="List View"><i class="ti ti-list-tree"></i></router-link>
    <router-link to="/crm/leads-grid" class="btn btn-icon btn-sm" title="Grid View"><i class="ti ti-layout-grid"></i></router-link>
   </div>
  </div>

  <div class="me-2 mb-2" v-if="data?.length">
  <div class="dropdown">
  <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown"><i class="ti ti-file-export me-1"></i>Export</a>
  <ul class="dropdown-menu dropdown-menu-end p-3">
  <li>
   <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile('csv')">
   <i class="ti ti-file-type-csv me-1"></i>Export as CSV
   </a>
  </li>
  <li>
   <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile('xlsx')">
   <i class="ti ti-file-type-xls me-1"></i>Export as Excel
   </a>
  </li>
  </ul>
  </div>
  </div>

  <div class="me-2 mb-2">
   <button type="button" class="btn btn-outline-secondary" @click="bulkAction();"><i class="ti ti-playstation-square me-1"></i> Bulk Actions</button> 
  </div>
  
  <div class="mb-2">
    <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#lead_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.leadModal.add();">
      <i class="ti ti-circle-plus me-2"></i>Add Lead
    </a>
  </div>
  
</div>
</div>
<!-- /Breadcrumb -->

<!-- Leads Grid -->
<div class="card">
 <div class="card-body p-3">
  <div class="d-flex align-items-center justify-content-between">
   <h5>Leads Grid</h5>
  <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-3" v-if="search_keyword !== '' || stage !== ''  || source !== ''  || user !== '' ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  
    
    <div class="me-3">
     <select class="form-select" v-model="stage" @change="leads">
      <option value="">Stage</option>
      <option :value="row.id" v-for="row in stages" :key="row.id">{{row.name}}</option>
     </select>
    </div>

    <div class="me-3">
     <select class="form-select" v-model="source" @change="leads">
      <option value="">Source</option>
      <option :value="row.id" v-for="row in sources" :key="row.id">{{row.name}}</option>
     </select>
    </div>

    <div class="me-3 custom-vueselect">
     <vue-select :options="users" label="name" v-model="user" :reduce="u => u.id" placeholder="All Users" @update:modelValue="leads()"/>
    </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="search_keyword" placeholder="Search...."/>
    </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="leads()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    </div>
  </div>
</div>

<!-- Leads Kanban -->
<div class="d-flex overflow-x-auto align-items-start mb-4">

<div class="kanban-list-items bg-white" v-for="(row, index) in data" :key="index">
<div class="card mb-0">
<div class="card-body">
<div class="d-flex justify-content-between align-items-center">
<div>
 <h4 class="fw-semibold d-flex align-items-center mb-1">
  <i class="ti ti-circle-filled fs-8 me-2" :style="{color: row.color}"></i>{{row.name}}
 </h4>
 <span class="fw-medium text-default">{{row.current_leads_count || row.leads.length}} of {{row.total_leads_count || row.leads.length}} Leads</span>
</div>
<!-- <div class="d-flex align-items-center">
 <div class="action-icon d-inline-flex">
  <a href="javascript:void(0);"><i class="ti ti-circle-plus"></i></a>
  <a href="javascript:void(0);" class="" data-bs-toggle="modal" data-bs-target="#edit_leads"><i class="ti ti-edit"></i></a>
  <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#delete_modal"><i class="ti ti-trash"></i></a>
 </div>
</div> -->
</div>
</div>
</div>
<div class="kanban-drag-wrap pt-4">

<draggable :list="row.leads" :group="{ name: 'kanban', pull: true, put: true }" @end="onDragEnd">

<div v-for="lead in row.leads" :key="lead.id">
<div class="card kanban-card">
<div class="card-body">
<div class="d-block">
<div class="color-class"></div>
<div class="d-flex align-items-center mb-3">
  <div class="form-check form-checkbox-success mb-2">
  <input type="checkbox" class="form-check-input" :value="lead.id" v-model="selected_rows" :disabled="lead.converted_at !== null">
  </div>
 <router-link :to="{name: 'leads-details', params: {id: lead.id} }" class="avatar avatar-lg bg-gray flex-shrink-0 me-2"><span class="avatar-title text-dark">{{$firstLetter(lead.name)}}</span></router-link>
  <h6 class="fw-medium">
  <router-link :to="{name: 'leads-details', params: {id: lead.id} }">{{lead.name}}</router-link>
  </h6>
</div>
</div>
<div class="mb-3 d-flex flex-column">
<p class="text-default d-inline-flex align-items-center mb-2" v-if="lead.email">
  <i class="ti ti-mail text-dark me-1"></i>
  {{lead.email}}
</p>
<p class="text-default d-inline-flex align-items-center mb-2">
  <i class="ti ti-phone text-dark me-1"></i>
  {{lead.mobile}}
</p>
<p class="text-default d-inline-flex align-items-center" v-if="lead.city || lead.state || lead.country">
  <i class="ti ti-map-pin-pin text-dark me-1"></i>
  {{lead.city}}, {{lead.state}} - {{lead.country}}
</p>
<p class="text-default d-inline-flex align-items-center mb-2">
 <span class="badge rounded-pill bg-outline-secondary d-inline-flex align-items-center">{{ lead.source?.name }}</span>
</p>
</div>
<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3">
 
 <span><img :src="$profileImage(lead.user.image, clientAdmin)" width="22" /> {{ lead.user.name }}</span>

<div class="icons-social d-flex align-items-center">
 <a :href="`tel:${lead.mobile}`" class="d-flex align-items-center justify-content-center me-2"><i class="ti ti-phone-call"></i></a>
 <a :href="`mailto:${lead.email}`" class="d-flex align-items-center justify-content-center me-2" v-if="lead.email"><i class="ti ti-mail"></i></a>
</div>
</div>
</div>
</div>
</div>
</draggable>

<!-- Load More Button - Only show if there are more leads -->
<div class="text-center mt-3" v-if="row.has_more_leads">
  <button 
    type="button" 
    class="btn btn-sm btn-outline-primary" 
    @click="loadMoreLeads(row.id, index)"
    :disabled="stageLoading[row.id]"
  >
    <span v-if="stageLoading && stageLoading[row.id]">
      <i class="ti ti-loader ti-spin me-1"></i>Loading...
    </span>
    <span v-else>
      <i class="ti ti-plus me-1"></i>Load More 
      <small class="text-muted">({{ row.current_leads_count }}/{{ row.total_leads_count }})</small>
    </span>
  </button>
</div>

<!-- No more leads message (optional) -->
<div class="text-center mt-2" v-else-if="row.total_leads_count > 0 && !row.has_more_leads">
  <small class="text-muted">All {{ row.total_leads_count }} leads loaded</small>
</div>

</div>
</div>
 
</div>
<!-- /Leads Kanban -->
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->
<leads-modal ref="leadModal" @updated="leads"></leads-modal>
</template>
